import { Helpers } from '../../helpers';
import { IDirectionalCostType } from '../../interfaces/idirectional-cost-type';
import { DirectionalCost } from '../directional-cost';

export class DirectionalCostTypeBase {
  DirectionalCostTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DirectionalCosts_DirectionalCostType?: Array<DirectionalCost> | null;

  constructor(item?: IDirectionalCostType) {
    if (item) {

      this.DirectionalCostTypeId = item.DirectionalCostTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DirectionalCosts_DirectionalCostType = Helpers.createClassArray(DirectionalCost, item.DirectionalCosts_DirectionalCostType);
    }
  }
}